import { useEffect, useState } from "react";

/**
 * Thin amber banner shown on every page of the preview/test deployment.
 * Hidden on the production custom domain (compcreator.nz / www.compcreator.nz).
 *
 * Detection is by hostname so it works regardless of the route or layout.
 */
const PRODUCTION_HOSTS = new Set([
  "compcreator.nz",
  "www.compcreator.nz",
]);

export default function PreviewBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const host = (window.location?.hostname || "").toLowerCase();
    setShow(!PRODUCTION_HOSTS.has(host));
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="preview-environment-banner"
      style={{
        background: "#FEF3C7",
        color: "#92400E",
        borderBottom: "1px solid #F59E0B",
        textAlign: "center",
        padding: "4px 12px",
        fontSize: "12px",
        fontWeight: 600,
        letterSpacing: "0.02em",
        lineHeight: 1.3,
      }}
    >
      PREVIEW ENVIRONMENT — changes here are not live until redeployed to compcreator.nz
    </div>
  );
}
